import O1HD from "../../../../engines/gameEngine";

const { ccclass, property } = cc._decorator;

@ccclass
export default class BackpackIconBtn extends cc.Component {


    @property({ type: cc.Prefab, displayName: "背包UI预制体" })
    backpackPrefab: cc.Prefab = null;

    onClick() {
        let backpack = cc.instantiate(this.backpackPrefab);
        O1HD.Canvas().addChild(backpack);
    }
}
